import _slicedToArray from "/builds/vistaprint-org/digital/acquisition/merchandising-components/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React__default, { useState, useMemo } from 'react';
import { SwanCollectionContext } from './collection.context.js';

function CollectionContextProvider(props) {
  var children = props.children;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      childItems = _useState2[0],
      setChildItems = _useState2[1];

  var contextValue = useMemo(function () {
    return {
      childItems: childItems,
      setChildItems: setChildItems
    };
  }, [childItems, setChildItems]);
  return /*#__PURE__*/React__default.createElement(SwanCollectionContext.Provider, {
    value: contextValue
  }, children);
}

export { CollectionContextProvider };